<template>
  <!-- class="recipientSelect" -->
  <v-select
    v-model="address"
    :class="[!address ? 'is-invalid': 'origin-selected', 'originSelect', 'custom-dropdown']"
    :clearable="false"
    ref="select"
    :options="options"
    label="text"
    :onChange="onChange"
    placeholder="Please Select an Origin Address"
  ></v-select>
</template>

<style lang="scss" scoped>
</style>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: ['options', 'selected'],
  data() {
    return {
      address: null,
    };
  },
  watch: {
    selected: function(val){
      this.address = val
    }
  },
  methods: {
    onChange(val) {
      if (!val || !val.value) {
        this.onClearItems();
        this.$emit('clear');
      }
      this.$emit('change', val);
    },
    onClearItems() {
      this.address = null;
    },
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Form/OriginSelect.vue